import { Component, inject } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ShowForRoleInDirective } from "@kno2/common/directives";
import { APP_CONFIG_TOKEN } from "@kno2/core/config";
import { environment } from "@kno2/environments";

@Component({
    selector: "kno2-footer",
    imports: [RouterLink, ShowForRoleInDirective],
    templateUrl: "./footer.component.html",
    styles: `
        footer .links {
            white-space: nowrap;
        }

        footer .links .sys-admin-link {
            padding: 0;
        }

        @media (max-width: 930px) {
            footer .light {
                display: none;
            }
        }
    `
})
export class FooterComponent {
    private readonly appConfig = inject(APP_CONFIG_TOKEN);

    public buildNumber = environment.buildNumber || "0.0.0";
    public year = new Date().getFullYear();
    public aboutUsUrl: string;

    public ngOnInit(): void {
        this.aboutUsUrl = this.appConfig.aboutUsUrl;
    }
}
